import * as React from 'react';
import {
	BooleanField,
	DateField,
	EmailField,
	ImageField,
	NumberField,
	ReferenceField,
	Show,
	ShowProps,
	SimpleShowLayout,
	TextField,
	UrlField
} from 'react-admin';
import { PhoneField } from '../components/PhoneField';
import { TranslateField } from '../components/TranslateField';

export const CoachShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<TextField source="fullName" label="FULL_NAME"/>
				<PhoneField source="user.phone" label="PHONE"/>
				<EmailField source="user.email" label="EMAIL"/>
				<ImageField source="profileImageUrl" label="PROFILE_IMAGE"/>
				<UrlField source="menuPdfUrl" label="MENU_PDF_URL"/>
				<DateField source="birthDate" label="BIRTH_DATE"/>
				<NumberField source="height" label="HEIGHT"/>
				<NumberField source="weight" label="WEIGHT"/>
				<TranslateField source="gender" label="GENDER"/>
				<TranslateField source="trainingType" label="TRAINING_TYPE"/>
				<ReferenceField source="coachId" reference="clients" label="COACH">
					<TextField source="fullName"/>
				</ReferenceField>

				<BooleanField source="approvedByCoach" label="APPROVED_BY_COACH"/>
				<TextField source="address.addressStr" label="ADDRESS"/>
				{/*<BooleanField source="shouldReceiveMotivationNotifications"*/}
				{/*              label="SHOULD_RECEIVE_MOTIVATION_NOTIFICATIONS"/>*/}
				{/*<BooleanField source="shouldReceiveWeightingReminder" label="SHOULD_RECEIVE_WEIGHTING_REMINDER"/>*/}
				{/*<BooleanField source="shouldReceiveSendingImageReminder" label="SHOULD_RECEIVE_SENDING_IMAGE_REMINDER"/>*/}
				{/*<BooleanField source="shouldCoachReceivePersonalMessagesReminder"*/}
				{/*              label="SHOULD_COACH_RECEIVE_PERSONAL_MESSAGES_REMINDER"/>*/}
				{/*<BooleanField source="shouldCoachReceiveTraineesProgressReminder"*/}
				{/*              label="SHOULD_COACH_RECEIVE_TRAINEES_PROGRESS_REMINDER"/>*/}
				{/*<BooleanField source="shouldCoachReceiveBirthdayNotifications"*/}
				{/*              label="SHOULD_COACH_RECEIVE_BIRTHDAY_NOTIFICATIONS"/>*/}
				{/*<BooleanField source="shouldCoachReceiveNonUploadersReminder"*/}
				{/*              label="SHOULD_COACH_RECEIVE_NON_UPLOADERS_REMINDER"/>*/}
				{/*<TextField source="note" label="NOTE"/>*/}
			</SimpleShowLayout>
		</Show>
	);
};
